import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      blue_50: { main: blue50 } = {},
      green_200: { main: green200 } = {},
      gray_400: { main: gray400 } = {},
      gray_300: { main: gray300 } = {},
      gray_50: { main: gray50 } = {},
      gray_stroke: { main: grayStroke } = {},
      white_100: { main: white100 } = {},
      yellow_400: { main: yellow400 } = {},
      yellow_100: { main: yellow100 } = {},
      red_100: { main: red100 } = {},
      dark_50: { main: dark50 } = {},
      dark_400: { main: dark400 } = {},
      dark_700: { main: dark700 } = {},
      dark_600: { main: dark600 } = {},
      dark_stroke: { main: darkStroke } = {}
    } = {}
  } = theme
  return {
    '@keyframes blink': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0
      },
      '100%': {
        opacity: 1
      }
    },
    mainWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    messageBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      width: '100%'
    },
    sideMenu: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '4px 0 10px 0',
      height: '100%',
      width: '35px',
      left: 0,
      bottom: 0,
      gap: '8px',
      backgroundColor: isDark ? dark400 : white100
    },
    messagePrivateMessage: {
      backgroundColor: yellow100,
      display: 'flex',
      gap: '6px',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        '& svg': {
          marginTop: '6px'
        }
      }
    },
    messagePrivate: {
      backgroundColor: dark700 + '!important',
      display: 'flex',
      gap: '6px',
      alignItems: 'center',
      justifyContent: 'center',
      '& textarea': {
        color: dark50,
        '&::placeholder': {
          color: dark50 + '!important'
        }
      }
    },
    messagePrivateText: {
      textAlign: 'center',
      fontWeight: 600,
      fontSize: '.8rem',
      padding: '8px 0 ',
      color: dark700
    },
    messagePrivateIcon: {
      color: dark700
    },
    newMessageBox: {
      display: 'flex',
      gap: '8px',
      padding: '7px',
      margin: '0 0 0 35px',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        margin: 0
      }
    },
    boxClosedTicket: {
      padding: '21px 0',
      fontFamily: 'Inter, sans-serif',
      color: gray400,
      textAlign: 'center',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%',
      boxSizing: 'border-box'
    },
    joinAttendanceWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      padding: '12px 0'
    },
    joinAttendanceButton: {
      borderRadius: 8,
      textTransform: 'none',
      fontWeight: 600
    },
    messageInputWrapper: {
      padding: '1px 4px',
      background: isDark ? dark400 : gray50,
      border: isDark ? '1px solid' + darkStroke : '1px solid' + grayStroke,
      display: 'flex',
      borderRadius: 8,
      flex: 1,
      // marginRight: 10,
      [theme.breakpoints.up('lg')]: {
        padding: '6px 10px'
      },
      [theme.breakpoints.down('sm')]: {
        padding: '8px'
      }
    },
    messageInput: {
      paddingLeft: 10,
      flex: 1,
      background: isDark ? dark400 : gray50,
      color: isDark ? dark50 : gray400,
      border: 'none !important',
      fontFamily: '"Roboto", "Noto Color Emoji", sans-serif',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        '& .MuiInputAdornment-positionEnd': {
          display: 'flex',
          gap: 8
        }
      }
    },
    pendingButtonsWrapper: {
      width: '100%',
      padding: '0 18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      marginTop: '8px',
    },
    sendMessageButton: {
      backgroundColor: blue300,
      borderRadius: 8,
      padding: 6,
      '&:hover': {
        backgroundColor: theme.palette.blue_400.main
      },
      [theme.breakpoints.up('lg')]: {
        padding: '10px'
      },
      [theme.breakpoints.down('sm')]: {
        padding: '14px 14px'
      }
    },
    sendMessageIcons: {
      color: white100,
      width: 20,
      height: 20,
      [theme.breakpoints.up('lg')]: {
        width: 24,
        height: 24
      }
    },
    buttonAction: {
      '& .MuiIconButton-root': {
        padding: '0px !important',
        border: 'none !important',
        outline: 'none !important',
        backgroundColor: 'transparent !important',
        '&:hover': {
          backgroundColor: 'transparent !important'
        }
      }
    },
    buttonActionFile: {
      // width: 20,
      // height: 20,
      color: isDark ? dark50 : gray300,
      '&:hover': {
        color: theme.palette.green_100.main
      },
      [theme.breakpoints.up('lg')]: {
        width: 24,
        height: 24
      }
    },
    buttonActionEmoji: {
      color: isDark ? dark50 : gray300,
      '&:hover': {
        color: yellow400
      }
    },
    buttonActionPix: {
      fontSize: '0.78rem',
      fontWeight: 700,
      letterSpacing: '0.2px',
      color: isDark ? green200 : theme.palette.green_100.main,
      textTransform: 'uppercase'
    },
    buttonActionSignature: {
      width: 20,
      height: 20,
      border: 0,
      color: props =>
        props.value
          ? blue300 // Cor quando ativado
          : isDark
            ? dark50
            : gray300,
      '&:hover': {
        color: blue300
      },
      [theme.breakpoints.up('lg')]: {
        width: 24,
        height: 24
      }
    },
    signSwitchControll: {
      color: gray400,
      marginRight: 0
    },
    uploadInput: {
      display: 'none'
    },
    viewMediaInputWrapper: {
      display: 'flex',
      padding: '5px 13px',
      // position: 'relative',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: isDark ? dark400 : white100,
      color: isDark ? dark50 : white100,
      // borderTop: '1px solid rgba(18, 4, 4, 0.12)'
      '& span': {
        color: gray400
      }
    },
    uploadBox: {
      width: '100%',
      height: 20
    },
    uploadPercent: {
      textAlign: 'center',
      width: '100%',
      '& p': {
        color: gray400
      }
    },
    progress: {
      backgroundColor: white100
    },
    emojiBox: {
      position: 'absolute',
      bottom: 80,
      left: 35,
      width: 40
    },
    circleLoading: {
      color: green200,
      opacity: '70%',
      position: 'absolute',
      top: '20%',
      left: '50%',
      marginLeft: -12
    },
    audioLoading: {
      color: green200,
      opacity: '70%'
    },
    recorderWrapper: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'middle'
    },
    cancelAudioIcon: {
      color: red100
    },
    sendAudioIcon: {
      color: green200
    },
    actionsIconButton: {
      padding: '4px',
      color: props =>
        props.value || props.internalNoteActive
          ? theme.palette.orange_400.main // Cor quando ativado
          : isDark
            ? dark50
            : gray300,
      '&:hover': {
        backgroundColor: isDark ? dark400 : white100
      }
    },
    replyginMsgWrapper: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 8,
      paddingLeft: 73,
      paddingRight: 7
    },
    replyginMsgContainer: {
      flex: 1,
      marginRight: 5,
      overflowY: 'hidden',
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderRadius: '7.5px',
      display: 'flex',
      position: 'relative'
    },
    replyginMsgBody: {
      padding: 10,
      height: 'auto',
      display: 'block',
      whiteSpace: 'pre-wrap',
      overflow: 'hidden'
    },
    replyginContactMsgSideColor: {
      flex: 'none',
      width: '4px',
      backgroundColor: '#35cd96'
    },
    replyginSelfMsgSideColor: {
      flex: 'none',
      width: '4px',
      backgroundColor: '#6bcbef'
    },
    messageContactName: {
      display: 'flex',
      color: '#6bcbef',
      fontWeight: 500
    },
    buttonActionQuickMessage: {
      width: 20,
      height: 20,
      color: isDark ? dark50 : gray300,
      '&:hover': {
        color: green200
      },
      [theme.breakpoints.up('lg')]: {
        width: 24,
        height: 24
      }
    },
    quickMessagesList: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '200px',
      overflowY: 'auto',
      padding: '8px'
    },
    quickMessageItem: {
      padding: '8px 12px',
      margin: '4px 0',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#f0f0f0'
      }
    },

    dragArea: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '4px',
      border: '1px dashed #aaa'
    },
    dragAreaContent: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      color: isDark ? dark50 : gray400,
      textAlign: 'center',
      '& p': {
        fontSize: '14px'
      }
    },

    buttonActionContact: {
      color: isDark ? dark50 : gray300,
      '&:hover': {
        color: blue300
      }
    },

    buttonActionBot: {
      color: isDark ? dark50 : gray300,
      '&:hover': {
        color: blue300
      }
    },

    // Estilos para o cartão de contato (vCard)
    vCardContainer: {
      maxWidth: '280px',
      backgroundColor: isDark ? '#2d3748' : '#ffffff',
      borderRadius: '12px',
      boxShadow: isDark
        ? '0 1px 3px rgba(0, 0, 0, 0.3)'
        : '0 1px 3px rgba(0, 0, 0, 0.12)',
      border: isDark ? '1px solid #4a5568' : '1px solid #e0e0e0',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s',
      margin: '8px 0',
      '&:hover': {
        transform: 'scale(1.02)',
        boxShadow: isDark
          ? '0 2px 8px rgba(0, 0, 0, 0.4)'
          : '0 2px 8px rgba(0, 0, 0, 0.15)'
      }
    },
    vCardHeader: {
      padding: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    vCardAvatar: {
      width: '48px',
      height: '48px',
      fontSize: '18px',
      fontWeight: 'bold'
    },
    vCardContent: {
      flex: 1,
      minWidth: 0
    },
    vCardName: {
      fontWeight: '600',
      fontSize: '16px',
      color: isDark ? '#f7fafc' : '#1f2937',
      margin: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    vCardDescription: {
      color: isDark ? '#a0aec0' : '#6b7280',
      fontSize: '14px',
      margin: '2px 0 0 0',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    vCardInfo: {
      padding: '0 16px 12px'
    },
    vCardPhoneContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 0'
    },
    vCardPhoneIcon: {
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px'
    },
    vCardPhone: {
      color: isDark ? '#e2e8f0' : '#374151',
      fontSize: '14px',
      fontFamily: 'monospace'
    },
    vCardAction: {
      borderTop: isDark ? '1px solid #4a5568' : '1px solid #f3f4f6',
      padding: '12px 16px',
      backgroundColor: isDark ? '#1a202c' : '#f9fafb',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    },
    vCardActionIcon: {
      width: '18px',
      height: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px'
    },
    vCardActionText: {
      color: isDark ? '#68d391' : '#059669',
      fontWeight: '600',
      fontSize: '14px'
    },

    // Contact modal
    dialog: {
      ...theme.scrollbarStyles
    },
    dialogTitle: {
      color: blue300
    },
    searchIcon: {
      color: isDark ? dark50 : gray400
    },
    contactListItem: {
      borderRadius: 8,
      padding: '2px 12px'
    },
    contactListItemText: {
      '& span': {
        color: isDark ? dark50 : gray400,
        fontSize: '.875rem',
        fontWeight: 600
      },
      '& p': {
        color: isDark ? dark50 : gray400,
        fontSize: '.875rem'
      }
    },
    noMoreContacts: {
      textAlign: 'center',
      padding: '10px',
      color: isDark ? dark50 : gray400,
      fontSize: '0.9rem',
      fontWeight: 500
    },
    listContacts: {
      display: 'flex',
      justifyContent: 'center',
      padding: '20px'
    },
    listContactsContainer: {
      backgroundColor: isDark ? dark400 : white100,
      borderRadius: '12px',
      padding: '4px 12px'
    },
    listContactsContent: {
      maxHeight: '400px',
      overflowY: 'auto',
      ...theme.scrollbarStyles
    },

    //Camera Modal
    cameraModalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      alignItems: 'center'
    },
    cameraModalError: {
      width: '100%',
      padding: '20px',
      backgroundColor: theme.palette.red_200.main,
      color: red100,
      borderRadius: '8px',
      textAlign: 'center'
    },
    cameraModalStart: {
      width: '100%',
      aspectRatio: '4/3',
      backgroundColor: isDark ? dark400 : theme.palette.gray_100.main,
      borderRadius: '16px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& span': {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '8px',
        color: isDark ? dark50 : gray400
      }
    },
    buttonPhoto: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '6px 16px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '.875rem'
    },
    cameraModalRecording: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '1rem',
      fontWeight: 'bold',
      color: red100,
      '& svg': {
        animation: '$blink 1s linear infinite'
      }
    },
    buttonCapture: {
      backgroundColor: green200,
      color: white100,
      borderRadius: 8,
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& .MuiButton-label': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      },
      '&:hover': {
        backgroundColor: blue300,
        boxShadow: 'none'
      }
    },
    buttonStop: {
      backgroundColor: red100,
      color: white100,
      '&:hover': {
        backgroundColor: red100
      }
    },

    //Menu Mobile
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& .MuiListItemIcon-root': {
        minWidth: 0
      }
    },
    iconButtonMenu: {
      color: blue300,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },

    actionIconButtonPix: {
      width: 22,
      height: 22,
      fill: isDark ? dark50 : gray300,
      transition: 'fill 0.2s ease-in-out',
      '&:hover': {
        fill: theme.palette.green_100.main // Sua cor de hover (ex: verde do Pix)
      }
    },
    buttonPix: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      padding: '10px',
      borderRadius: '12px',
      textAlign: 'left',
      border: isDark ? `1px solid ${darkStroke}` : `1px solid ${grayStroke}`,
      backgroundColor: isDark ? dark400 : white100,
      cursor: 'pointer',
      outline: 'none',
      '&:hover': {
        border: '1px solid' + blue300
      }
    },
    botOptionButton: {
      width: '100%',
      padding: '12px 0',
      borderRadius: '12px',
      border: isDark ? `1px solid ${darkStroke}` : `1px solid ${grayStroke}`,
      backgroundColor: isDark ? dark400 : white100,
      color: blue300,
      fontWeight: 600,
      fontSize: '1rem',
      cursor: 'pointer',
      outline: 'none',
      '&:hover': {
        border: '1px solid' + blue300
      },
      '&:disabled': {
        opacity: 0.5,
        cursor: 'default'
      }
    },
    boxPixIcon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '40px',
      height: '40px',
      borderRadius: '10px',
      backgroundColor: isDark ? dark600 : blue50,
      color: blue300,
      marginRight: '14px',
      flexShrink: 0
    },
    pixName: {
      fontWeight: 600,
      color: blue300,
      fontSize: '.875rem',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    pixKey: {
      color: isDark ? dark50 : gray400,
      fontSize: '0.8rem',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      marginTop: '2px'
    },
    chipPix: {
      display: 'inline-block',
      padding: '2px 6px',
      borderRadius: '6px',
      marginTop: '6px',
      backgroundColor: isDark ? dark600 : blue50,
      color: isDark ? dark50 : gray400,
      fontSize: '0.7rem',
      fontWeight: 500,
      textTransform: 'uppercase'
    }
  }
})
